import {
  gameIdsByLicensedTerritory,
  type LicensedTerritory,
} from '@lottocom/high-frequency-game-mapping'

export const useHighFrequencyGamesOfLicensedTerritory = () => {
  const licensedTerritory = useLicensedTerritory({
    raw: true,
  }) as LicensedTerritory

  const highFrequencyGameIds = gameIdsByLicensedTerritory[licensedTerritory]

  const doesExist = (gameId: string) =>
    highFrequencyGameIds
      .map((v) => v.toLowerCase())
      .includes(gameId.toLowerCase())

  const getHighFrequencyGameIdInCorrectCase = (anyCaseGameId?: unknown) =>
    highFrequencyGameIds.find(
      (gameId) => gameId.toLowerCase() === String(anyCaseGameId).toLowerCase(),
    ) ?? null

  return {
    doesExist,
    getHighFrequencyGameIdInCorrectCase,
    highFrequencyGameIds,
  }
}
